module.exports = __webpack_public_path__ + "img/play.c8f4f26a.svg";